<template>
  <div>
    <van-pull-refresh :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
      >
        <vanCollapseContent :type="orderKey" :list = list ></vanCollapseContent>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import vanCollapseContent from './OrderVanCollapseContent.vue'
import { flowAddOrder, saleOrder } from '@/api/user.js'
export default {
  name: 'OrderVan',
  components: { vanCollapseContent },
  props: {
    orderKey: {
      type: String
    },
    list: {
      type: Array
    },
    paramsList: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      finishedText: '',
      // 刷新节流阀
      refreshingFlag: false,
      allList: []
    }
  },
  watch: {},
  computed: {},
  methods: {
    async rechargeOrder () {
      const { data: res } = await saleOrder(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      if (res.code === 1) return
      this.finishedText = '没有更多充值订单了'
      // res.extend.rows.forEach(item => {
      //   item.recharge_date = item.recharge_date.split('T')[0] + ' ' + item.recharge_date.split('T')[1].split('.')[0]
      // })
      this.allList = res.extend.rows
      this.$emit('change', {
        list: this.allList,
        type: 'add'
      })
      this.loading = false
      if (this.allList.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    async flowOrder () {
      const { data: res } = await flowAddOrder(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      if (res.code === 1) return
      this.finishedText = '没有更多流量包订单了'
      // res.extend.rows.forEach(item => {
      //   item.rechargeDate = item.rechargeDate.split('T')[0] + ' ' + item.rechargeDate.split('T')[1].split('.')[0]
      // })
      this.allList = res.extend.rows
      this.$emit('change', {
        list: this.allList,
        type: 'add'
      })
      this.loading = false
      if (this.allList.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    onLoad () {
      if (this.orderKey === '流量') {
        this.flowOrder()
      } else {
        this.rechargeOrder()
      }
    },
    onRefreshs () {
      this.refreshingFlag = true
      // 清空列表数据
      this.finished = false
      this.$emit('change', {
        list: [],
        type: 'refreshs'
      })
      this.paramsList.page = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
</style>
